import React from "react";
import { content } from "./badge.css";
import { vars } from "@puzzle/theme";

const DEFAULT_TOP_COUNT_THRESHOLD = 99;

export type BadgeProps = {
  count?: number | null;
  topCountThreshold?: number;
} & React.ComponentPropsWithoutRef<"span">;

export const Badge = ({
  count = 0,
  topCountThreshold = DEFAULT_TOP_COUNT_THRESHOLD,
  ...spanProps
}: BadgeProps) => {
  const displayCount = count ?? 0;
  const isCountGreaterThanThreshold = displayCount > topCountThreshold;

  const reviewedCount = isCountGreaterThanThreshold
    ? `${topCountThreshold}+`
    : displayCount.toString();
  const fontSize = isCountGreaterThanThreshold ? vars.fontSizes.bodyXXS : vars.fontSizes.bodyS;

  if (displayCount === 0) {
    return null;
  }

  return (
    <div className={content}>
      <span style={{ fontSize }} {...spanProps}>
        {reviewedCount}
      </span>
    </div>
  );
};
